<div fxLayout="column">
    <div fxFlex="0 0 calc(100vh-70px)" fxLayout="column">
        <div fxLayout="row">
            <div [fxHide]="viewMode != 'DASHBOARD' || !selectedMetricData" fxFlex="1 1 auto">
                <button mat-button class="risk-manager-menu-button" (click)="onDashboard()">
                    <mat-icon>navigate_before</mat-icon>
                    <span>Dashboard</span>
                </button>
                <p-selectButton [options]="breakDownConfigs" [(ngModel)]="selectedBreakDownConfig"
                    (onChange)="onBreakDownConfig()"></p-selectButton>
            </div>
            <div fxFlex="1000 0 auto" fxLayoutAlign="stretch"></div>
        </div>
        <app-dashboard-metric-bar #dashboardMetricBar fxFlex="1 2 auto" [fxHide]="viewMode != 'DASHBOARD' || selectedMetricData">
        </app-dashboard-metric-bar>
        <app-simulation fxFlex="1 1 auto" [fxHide]="viewMode != 'SIMULATION'">
        </app-simulation>
        <div fxLayout="column" [fxHide]="viewMode != 'DASHBOARD' || !selectedMetricData">
            <div fxFlex="1 1 50vh" fxLayout="row" class="liquitics-box">
                <!-- <div fxFlex="1 1 100%" id='breakdownsunburstchartdiv' class="chartdiv"></div> -->
                <div fxFlex="1 1 50%">
                    <p-treeTable [loading]="!breakDownTreeNodes" [scrollable]="true" scrollHeight="50vh"
                        [value]="breakDownTreeNodes" [(selection)]="selectedBreakDownNode" selectionMode="single"
                        (onNodeSelect)="breakDownNodeSelected($event)">
                        <ng-template pTemplate="colgroup" let-columns>
                            <colgroup>
                                <col style="width:80%">
                                <col style="width:20%">
                            </colgroup>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="center">Metric</th>
                                <th class="center">Value</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                            <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode" [ngClass]="'level-' + rowData.level">
                                <td>
                                    <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                                    {{rowData.breakDown}}
                                </td>
                                <td class="center">{{rowData.amounts[0] | number:'1.2-2'}}</td>
                            </tr>
                        </ng-template>
                    </p-treeTable>
                </div>
                <div fxFlex="1 1 65%" fxLayout="column">
                    <span class="selected-path" fxFlex="0 1 5%">{{selectedBreakDownPath}}</span>
                    <p-treeTable *ngIf="selectedMetricConfig" [scrollable]="true" scrollHeight="50vh"
                        [value]="ladderTreeNodes">
                        <ng-template pTemplate="colgroup" let-columns>
                            <colgroup>
                                <col style="width:30%">
                                <ng-template ngFor let-item [ngForOf]="selectedMetricConfig.ladderValueNames"
                                    let-i="index">
                                    <col>
                                </ng-template>
                            </colgroup>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="center">Bucket</th>
                                <ng-template ngFor let-item [ngForOf]="selectedMetricConfig.ladderValueNames"
                                    let-i="index">
                                    <th class="center">{{selectedMetricConfig.ladderValueNames[i]}}</th>
                                </ng-template>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                            <tr [ttRow]="rowNode" [ngClass]="'level-' + rowData.level">
                                <td class="center">
                                    <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                                    {{rowData.breakDown}}
                                </td>
                                <ng-template ngFor let-item [ngForOf]="selectedMetricConfig.ladderValueNames"
                                    let-i="index">
                                    <td class="right">{{rowData.amounts[i] | number:'1.2-2'}}</td>
                                </ng-template>

                            </tr>
                        </ng-template>
                    </p-treeTable>
                </div>
            </div>
            <div class="liquitics-box" fxFlex="1 1 35vh" fxLayout="row">
                <div fxFlex="1 1 100%" fxLayout="column">
                    <div fxLayout="row">
                        <div *ngIf="selectedMetricConfig" fxFlex="1 1 100%" fxLayout="row">
                            <app-alm-historical-chart class="chartwrapper-35" fxFlex="1 1 auto" title="Historical Break Down" index=0 [historicalData]="historicalData"></app-alm-historical-chart>
                            <ng-template ngFor let-item [ngForOf]="selectedMetricConfig.ladderValueNames" let-i="index">
                                <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper-35 liquitics-box">
                                    <span class="center">{{item}}</span>
                                    <div>
                                        <div [attr.id]="'ladderchartdiv'+i" class="chartdiv"></div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>